import React from "react";
import NotificationBannerProvider from "../NotificationBanner";
import Sidebar from "./Sidebar";

const GlobalLayout = ({ children, sider, breadcrumb }) => {
  return (
    <NotificationBannerProvider>
      <main className="layout">
        <Sidebar menu={sider.menu} actions={sider.actions} />
        <div className="children--layout container">{children}</div>
      </main>
    </NotificationBannerProvider>
  );
};

export default GlobalLayout;
